import { render, staticRenderFns } from "./WeekDaysView.vue?vue&type=template&id=4954402b&scoped=true"
import script from "./WeekDaysView.vue?vue&type=script&lang=js"
export * from "./WeekDaysView.vue?vue&type=script&lang=js"
import style0 from "./WeekDaysView.vue?vue&type=style&index=0&id=4954402b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954402b",
  null
  
)

export default component.exports